export default __webpack_public_path__ + "static/media/MyriadProRegular.a2bb21a7.ttf";